import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface TaxOfficeCode {
    code: string; name: string;
}

export class TaxOfficeQuery extends Query<TaxOfficeCode> {
    public constructor(public readonly parameters: { id: string }) {
        super();
    }
}

export class TaxOfficeQueryHandlerBase implements QueryHandler<TaxOfficeQuery, TaxOfficeCode> {
    public static Url = TaggedUrl.join('system/taxOffices/:id', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(query: TaxOfficeQuery): Promise<TaxOfficeCode> {
        const { data } = await this.http.get<TaxOfficeCode>(fillPlaceholders(TaxOfficeQueryHandlerBase.Url, { id: query.parameters.id }));

        return data;
    }
}
